export default __webpack_public_path__ + "static/media/LiquidCoolingImg.b5dec9a4.jpg";